function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.001-.002h125.205v125.205H0z",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.052 .031) scale(4.16667)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-small_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h30.025v30H0z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-small_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.037,
  cy: 15.017,
  r: 15,
  fill: "#0d65f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.751 4.273a11.053 11.053 0 00-1.714-.134c-6.008 0-10.878 4.87-10.878 10.878s4.87 10.878 10.878 10.878 10.878-4.87 10.878-10.878c0-4.182-2.411-8.01-6.183-9.815v4.532a7.072 7.072 0 012.371 5.283 7.089 7.089 0 01-5.352 6.859V4.273zM7.97 15.017a7.09 7.09 0 015.568-6.909v13.818a7.09 7.09 0 01-5.568-6.909z",
  fill: "#fff"
})));

function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126 126",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MiIgdmlld0JveD0iMCAwIDEyNiAxMjYiPjxwYXRoIGQ9Ik00OC44NDEtNDYuNDMxSDc4Ljg5djMwLjA0OUg0OC44NDF6IiBzdHlsZT0iZmlsbDpub25lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzLjUwMyAxOTMuNDYxKSBzY2FsZSg0LjE2NjY3KSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMDUyIC4wMzEpIHNjYWxlKDQuMTY2NjcpIj48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGQ9Ik0wIDBoMzAuMDI1djMwSDB6Ii8+PC9jbGlwUGF0aD48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxjaXJjbGUgY3g9IjE1LjAzNyIgY3k9IjE1LjAxNyIgcj0iMTUiIHN0eWxlPSJmaWxsOiMwZDY1ZjIiLz48cGF0aCBkPSJNMTYuNzUxIDQuMjczYTExLjA1MyAxMS4wNTMgMCAwIDAtMS43MTQtLjEzNGMtNi4wMDggMC0xMC44NzggNC44Ny0xMC44NzggMTAuODc4czQuODcgMTAuODc4IDEwLjg3OCAxMC44NzggMTAuODc4LTQuODcgMTAuODc4LTEwLjg3OGMwLTQuMTgyLTIuNDExLTguMDEtNi4xODMtOS44MTV2NC41MzJhNy4wNzIgNy4wNzIgMCAwIDEgMi4zNzEgNS4yODMgNy4wODkgNy4wODkgMCAwIDEtNS4zNTIgNi44NTlWNC4yNzNaTTcuOTcgMTUuMDE3YTcuMDkgNy4wOSAwIDAgMSA1LjU2OC02LjkwOXYxMy44MThhNy4wOSA3LjA5IDAgMCAxLTUuNTY4LTYuOTA5WiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvZz48L2c+PC9zdmc+";
export { SvgLogoSmall as ReactComponent };